/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Close_CtaInputs */

const en_landing_close_cta = /** @type {(inputs: Landing_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time`)
};

const pl_landing_close_cta = /** @type {(inputs: Landing_Close_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz termin`)
};

/**
* | output |
* | --- |
* | "Pick a time" |
*
* @param {Landing_Close_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_close_cta = /** @type {((inputs?: Landing_Close_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Close_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_close_cta(inputs)
	return en_landing_close_cta(inputs)
});